export default "__VITE_ASSET__DyOPzgfh__"